import { action } from 'sky-engine/api/index'

import { DELIVERY_PROJECT_MNG } from '@/api/apiModules'
/**
 * 更新步骤
 * @param {*} data
 * @returns
 */
export function updateFlowStatus(data) {
  return action(DELIVERY_PROJECT_MNG, 'updateFlowStatus', data)
}

/**
 * 创建项目
 * @param {*} data
 * @returns
 */
export function createProject(data) {
  return action(DELIVERY_PROJECT_MNG, 'create', data)
}

/**
 * 修改项目
 * @param {*} data
 * @returns
 */
export function editProject(data) {
  return action(DELIVERY_PROJECT_MNG, 'edit', data)
}

/**
 * 查询项目
 * @param {*} data
 * @returns
 */
export function getDetail(data) {
  return action(DELIVERY_PROJECT_MNG, 'detail', data)
}

/**
 * 设置项目模版
 * @param {*} data
 * @returns
 */
export function setDdProjectTemplate(data) {
  return action(DELIVERY_PROJECT_MNG, 'setDdProjectTemplate', data)
}

/**
 * 获取交付向导默认的产品版本
 * @param {*} data
 * @returns
 */
export function getDefaultProductVersion(data) {
  return action(DELIVERY_PROJECT_MNG, 'default/productVersion', data)
}
